import { render, staticRenderFns } from "./AddRefundRecordModal.vue?vue&type=template&id=06d51b24&scoped=true"
import script from "./AddRefundRecordModal.vue?vue&type=script&lang=ts"
export * from "./AddRefundRecordModal.vue?vue&type=script&lang=ts"
import style0 from "./AddRefundRecordModal.vue?vue&type=style&index=0&id=06d51b24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d51b24",
  null
  
)

export default component.exports